import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Area } from '../../../core/constants/area';
import { tap } from 'rxjs/operators';
import { AddFrequencyModel } from './models/addFrequencyModel';
import { EditServiceSubscriptionModel } from './models/editServiceSubscriptionModel';
import { SubscriptionServiceTypeModel } from './models/subscriptionServiceTypeModel';
import { RateBuilderModel } from './models/rateBuilderModel';
import { CompanyDropdownResponse } from '../../../fleet-manager/company/models/responses';
import { SetSubscriptionRateModel } from './models/setSubscriptionRateModel';
import { CreateCompanyDriverSubscriptionModel } from './models/createCompanyDriverSubscriptionModel';

@Injectable()
export class ServiceSubscriptionEditorService {
	constructor(public httpClient: HttpClient) { }

	deactivateRate(subscriptionId, rateId) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/ArchiveSubscriptionRate?subscriptionId=${subscriptionId}&rateId=${rateId}`;
		return this.httpClient.post<any[]>(url, {});
	}

	generateInvoice(subscriptionId: number, companyId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/GenerateInvoice`;
		return this.httpClient.post<any[]>(url, { subscriptionId, companyId });
	}

	getChargeTypes() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/Charge/ActiveTypeDropdown`;
		return this.httpClient.get<any>(url);
	}

	public getCompanyDriverRates(companyId: number){
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/Company/DriverRates?companyId=${companyId}`;
		return this.httpClient.get<any[]>(url); 
	}

	getCompanyDropdown() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/Company/Dropdown`;
		return this.httpClient.get<CompanyDropdownResponse[]>(url);
	}

	getCompanyServices(companyId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/companyServices/ByCompany?companyId=${companyId}`;
		return this.httpClient.get<any[]>(url).pipe(
			tap((cs: any[]) =>
				cs.forEach((x) => {
					x.startDate = x.startDate ? new Date(x.startDate) : null;
					x.endDate = x.endDate ? new Date(x.endDate) : null;
				})
			)
		);
	}

	public getDefaultDriverRates(){
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/DefaultDriverRates`;
		return this.httpClient.get<any[]>(url); 
	}

	getFrequencyDropdown() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/frequency/Dropdown`;
		return this.httpClient.get<any[]>(url);
	}

	getList(activeOnly: boolean) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/List?activeOnly=${activeOnly}`;
		return this.httpClient.get<any[]>(url);
	}

	getRateDropdown() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/Dropdown`;
		return this.httpClient.get<any[]>(url);
	}

	getRateFullList() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/FullList`;
		return this.httpClient.get<any[]>(url);
	}

	getRateList(subscriptionId: number, companyIds: number[]) {
		let url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/List?subscriptionId=${subscriptionId}`;
		companyIds.forEach((companyId) => {
			url += `&companyIds=${companyId}`;
		});
		return this.httpClient.get<any[]>(url);
	}
	
	getServiceCodeDropdown() {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/ServiceCode/Dropdown`;
		return this.httpClient.get<any[]>(url);
	}

	patchArchiveServiceSubscription(subscriptionId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Archive/${subscriptionId}`;
		return this.httpClient.patch<any[]>(url, {});
	}

	patchArchiveSubscription(subscriptionId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Archive/Company?companySubscriptionId=${subscriptionId}`;
		return this.httpClient.patch<any[]>(url, {});
	}

	patchOverrideSubscription(subscriptionId: number, override: boolean) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Override?companySubscriptionId=${subscriptionId}&isOverride=${override}`;
		return this.httpClient.patch<any[]>(url, {});
	}

	postFrequencySchedule(schedule: AddFrequencyModel) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/frequency/Schedule`;
		return this.httpClient.post<any[]>(url, schedule);
	}

	public postCompanyDriverRates(rates: CreateCompanyDriverSubscriptionModel[]){
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Company/DriverRate`;
		return this.httpClient.post<any[]>(url, rates); 
	}

	postRate(subscription: RateBuilderModel) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate`;
		return this.httpClient.post<any[]>(url, subscription);
	}

	postServiceSubscription(subscription: EditServiceSubscriptionModel) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription`;
		return this.httpClient.post<any[]>(url, subscription);
	}

	setSubscriptionRateBatch(rates: SetSubscriptionRateModel[]) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Rate/Batch`;
		return this.httpClient.post<any[]>(url, rates);
	}

	setSubscriptionTypeBatch(batches: SubscriptionServiceTypeModel[]) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/ServiceType/Batch`;
		return this.httpClient.post<any[]>(url, batches);
	}
}



// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/service-subscription-editor.service.ts